import Typography from "@/ui/atoms/Typography"
import { classNames } from "@punks/ui-core"
import { ReactNode, useState } from "react"

export type SelectableItemsListClasses = {
  root?: string
  item?: string
  title?: string
  description?: string
}

export type SelectableItemsListItem = {
  title: ReactNode
  description: ReactNode
}

export interface SelectableItemsListProps {
  items: SelectableItemsListItem[]
  imageDefault: ReactNode
  imageSelected?: ReactNode
  className?: string
  classes?: SelectableItemsListClasses
}

const SelectableItemsList = ({
  imageDefault,
  imageSelected,
  items,
  className,
  classes,
}: SelectableItemsListProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  return (
    <div className={classNames(className, classes?.root)}>
      <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center">
        {items.map((item, index) => (
          <div
            className={classNames(
              "relative flex justify-center items-center w-[246px] h-[246px] cursor-pointer",
              {
                "text-white": index === selectedIndex,
                "text-black": index !== selectedIndex,
              },
              classes?.item
            )}
            onClick={() => setSelectedIndex(index)}
            key={index}
          >
            <div className="absolute inset-0">
              {index === selectedIndex ? imageSelected : imageDefault}
            </div>
            <Typography
              textTransform={"uppercase"}
              variant={"body1"}
              weight={"bold"}
              className={classNames("z-[1]", classes?.title)}
            >
              {item.title}
            </Typography>
          </div>
        ))}
      </div>
      <div className={classNames("my-16 mx-auto", classes?.description)}>
        <Typography textAlign={"center"}>
          {items[selectedIndex].description}
        </Typography>
      </div>
    </div>
  )
}

export default SelectableItemsList
